import { useAppContext } from "../context/AppContext";
import type { UserRole } from "../types";

export interface RoleFlags {
  isAdmin: boolean;
  isSecretary: boolean;
  isOfficer: boolean;
  isEntity: boolean;
  // Admin and secretary can manage the data layer (jobs, entities, tiers).
  canManageData: boolean;
  // Admin only — audit log, officer approvals, settings.
  canAdminister: boolean;
}

export function getRoleFlags(role: UserRole | null | undefined): RoleFlags {
  const isAdmin = role === "admin";
  const isSecretary = role === "secretary";
  return {
    isAdmin,
    isSecretary,
    isOfficer: role === "officer",
    isEntity: role === "entity",
    canManageData: isAdmin || isSecretary,
    canAdminister: isAdmin,
  };
}

export function useRole(): RoleFlags {
  const { currentUser } = useAppContext();
  return getRoleFlags(currentUser?.role);
}
